import useInitializeCustomerAdvancedForm from './useInitializeCustomerAdvancedForm'

export default useInitializeCustomerAdvancedForm
